const DOMAIN = 'https://corporate-event-planner-webeu.herokuapp.com';

export default DOMAIN;
